// src/services/socketService.js

import io from 'socket.io-client';

 const SOCKET_SERVER_URL = 'https://api.gp-pay.net';


const socket = io(SOCKET_SERVER_URL, {
    autoConnect: false,
    reconnection: true,
    reconnectionAttempts: 5,
    reconnectionDelay: 1000,
    // 🔑 প্রতিবার connect/reconnect এ localStorage থেকে সর্বশেষ token পাঠাবে (server এর io.use middleware যাচাই করবে)
    auth: (cb) => {
        const token = (typeof localStorage !== 'undefined') ? localStorage.getItem('token') : null;
        cb(token ? { token } : {});
    }
});

const socketService = {
    connect: () => {
        if (!socket.connected) {
            socket.connect();
            console.log("SERVICE LOG: Socket connect initiated.");
        }
    },
    
    disconnect: () => {
        if (socket.connected) {
            socket.disconnect();
            console.log("SERVICE LOG: Socket disconnect initiated.");
        }
    },
    
    on: (event, callback) => {
        socket.on(event, callback);
    },

    once: (event, callback) => {
        socket.once(event, callback);
    },
    
    off: (event, callback) => {
        socket.off(event, callback);
    },
    
    // 🛠️ FIX: এখানেই আপনার কলব্যাক রিসিভ করার কোডটি ঠিক করা হয়েছে
    emit: (event, data, callback) => {
        if (typeof callback === 'function') {
            socket.emit(event, data, callback);
        } else {
            socket.emit(event, data);
        }
    },
    
    getSocket: () => socket,
};

export default socketService;